// extracted by mini-css-extract-plugin
module.exports = {"list":"SectionDetails_list__d12Lx"};